module.exports = __webpack_public_path__ + "media/audio34.e3d332e3.mp3";